var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStoreLine = function SvgStoreLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#store-line_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.497 9.705V17.5a.833.833 0 0 1-.833.833H3.331a.833.833 0 0 1-.834-.833V9.705A3.32 3.32 0 0 1 1.664 7.5v-5a.833.833 0 0 1 .833-.833h15a.833.833 0 0 1 .834.833v5c0 .845-.315 1.617-.834 2.205m-1.666 1.023a3.34 3.34 0 0 1-3.334-1.023 3.33 3.33 0 0 1-2.5 1.128 3.33 3.33 0 0 1-2.5-1.128 3.33 3.33 0 0 1-3.333 1.023v5.938h11.667zM11.664 7.5a.834.834 0 0 1 1.667 0 1.667 1.667 0 1 0 3.333 0V3.333H3.331V7.5a1.667 1.667 0 0 0 3.333 0 .833.833 0 1 1 1.667 0 1.667 1.667 0 0 0 3.333 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "store-line_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgStoreLine;